import Model from '../orm/Model'

import Course from './Course'
import Beacon from './Beacon'
import Event from './Event'

export default class Location extends Model {

    static entity = 'locations'

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            place_id: this.attr(null),
            beacons: this.hasMany(Beacon, 'location_id'),
            courses: this.hasMany(Course, 'location_id'),
            events: this.hasMany(Event, 'location_id'),
            activity_graph: this.array([], ['label', 'value']),
            beacons_count: this.attr(0),
            courses_count: this.attr(0),
            has_beacons: this.attr(false),
            note: this.attr('')
        }
    }

    static graphql = {
        all: {
            paginated: true,
            parameters: {
                page: 'Int',
                query: 'String',
                per_page: 'Int',
                sort_by: 'String',
                sort_dir: 'String'
            },
            exclude: { courses: true }
        },
        one: {
            type: 'location',
            parameters: {
                id: 'Int!'
            },
            include: [
                'courses',
                'events',
                'beacons',
                'activity_graph' 
            ],
            exclude: {
                events: [ 
                    'attending_count',
                    'waitlist_count',
                    'in_waitlist'
                ]
            }
        },
        create: {
            type: 'createLocation',
            parameters: {
                name: 'String!',
                note: 'String'
            }
        },
        update: {
            type: 'updateLocation',
            parameters: {
                id: 'Int!',
                note: 'String'
            }
        },
        remove: {
            type: 'removeLocation',
            parameters: {
                id: 'Int!'
            }
        },
        removeBeacon: {
            type: 'removeBeaconFromLocation',
            parameters: {
                beacon: 'String!'
            }
        }
    }
}
